import { get, post, put, destroy } from "./base";

const DealServ = {
    // Get all deals
    index: (params) => get("/today-deals", { params }),

    // Get seller's own deals
    getMyDeals: (params) => get("/today-deals/my-deals", { params }),

    // Create a deal
    create: (payload) => post("/today-deals", payload),

    // Update a deal
    update: (id, payload) => put(`/today-deals/${id}`, payload),

    // Delete a deal
    remove: (id) => destroy(`/today-deals/${id}`),

    // Get today's deals
    getTodayDeals: (params) => get("/today-deals", { params: { ...params, type: "today" } }),

    // Get deals ending soon
    getEndingSoonDeals: (params) => get("/today-deals/ending-soon", { params }),

    // Deactivate all deals for a specific product
    deactivateByProduct: (productId) => post(`/today-deals/deactivate-by-product/${productId}`),
};

export default DealServ;
